import React from 'react';

//components
import PageHeader from '../../../PageHeader/PageHeader.js'
import PageInfo from '../../components/PageInfo.js';
import ImageGallery from '../../components/ImageGallery.js';
import PageState from '../../components/PageState.js';

//Style
import styles from "./Index.module.css"

export default function KikreligeHandlinger() {
    return(
        <PageState
            pageName="KirkeligeHandlinger"
            render={({ data, sections, sectionNames }) => {

                const {Sec1, Sec2, Sec3, Sec4, Gallery} = data

                return (
                    <div>
                        <PageHeader
                            image={data.PageHeader.imageUrl}
                            title={data.PageHeader.title}
                            description={data.PageHeader.text}
                            sections={sections}
                            sectionNames={sectionNames} />
                        {/* Dåb */}
                        <section id={Sec1.secId} className={styles.sec1}>
                            <PageInfo 
                                title={Sec1.header}
                                description={<div dangerouslySetInnerHTML={{ __html: Sec1.text }}/>}
                                image={""}
                                version={"v1"}/>
                        </section>
                        {/* Konfirmation */}
                        <section id={Sec2.secId} className={styles.sec2}>
                            <PageInfo 
                                title={Sec2.header}
                                description={<div dangerouslySetInnerHTML={{ __html: Sec2.text }}/>}
                                image={""}
                                version={"v1"}/>
                        </section>
                        <section className={styles.gallery}>
                            <ImageGallery images={Gallery.images}/>
                        </section>
                        {/* Bryllup */}
                        <section id={Sec3.secId} className={styles.sec3}>
                            <PageInfo 
                                title={Sec3.header}
                                description={<div dangerouslySetInnerHTML={{ __html: Sec3.text }}/>}
                                image={""}
                                version={"v1"}/>
                        </section>
                        {/* Begravelse */}
                        <section id={Sec4.secId} className={styles.sec4}>
                            <PageInfo 
                                title={Sec4.header}
                                description={<div dangerouslySetInnerHTML={{ __html: Sec4.text }}/>}
                                image={""}
                                version={"v1"}/>
                        </section>
                    </div>
                );
            }
        }/>
    );
}